import { Star, TrendingUp } from 'lucide-react';

export const LandingGamification = () => (
  <section className="py-16 md:py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">Sistema de Gamificação</h2>
          <p className="text-base text-slate-600 mb-6">Quanto mais você usa e valida suas compras, mais pontos acumula!</p>
          <div className="space-y-4">
            {[
              { title: 'Validações de Compra', desc: '+10 pontos por validação' },
              { title: 'Depoimentos', desc: '+2 pontos por estrela' },
              { title: 'Fotos', desc: '+5 pontos por foto' }
            ].map((item, i) => (
              <div key={`gamif-${i}`} className="flex items-start gap-3">
                <div className="bg-amber-500 rounded-full w-8 h-8 flex items-center justify-center shrink-0">
                  <Star className="h-4 w-4 text-white" />
                </div>
                <div><h3 className="font-bold text-slate-900 mb-1">{item.title}</h3><p className="text-sm text-slate-600">{item.desc}</p></div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
          <div className="text-center">
            <TrendingUp className="h-16 w-16 text-amber-500 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-slate-900 mb-2">Suba de Nível</h3>
            <p className="text-slate-600 mb-6">A cada 100 pontos você desbloqueia cupons premium</p>
            <div className="bg-slate-100 rounded-md p-4">
              <div className="flex justify-between text-sm mb-2">
                <span className="text-slate-600">Nível 5</span>
                <span className="font-bold text-amber-500">480/500</span>
              </div>
              <div className="bg-slate-200 h-3 rounded-full overflow-hidden">
                <div className="bg-amber-500 h-full" style={{ width: '96%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
